module.exports = __webpack_public_path__ + "assets/img/new-20-logo.bb85160e.png";